// extracted by mini-css-extract-plugin
module.exports = {"instagramIcon":"_2THaQ"};